import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Tag = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M13 30C12.199 30 11.445 29.688 10.879 29.121L2.879 21.121C2.312 20.554 2 19.801 2 19C2 18.199 2.312 17.445 2.879 16.879L16.879 2.879C17.446 2.312 18.199 2 19 2H27C28.654 2 30 3.346 30 5V13C30 13.801 29.688 14.555 29.121 15.121L15.121 29.121C14.554 29.688 13.801 30 13 30ZM19 4C18.733 4 18.482 4.104 18.293 4.293L4.293 18.293C4.104 18.482 4 18.733 4 19C4 19.267 4.104 19.518 4.293 19.707L12.293 27.707C12.482 27.896 12.733 28 13 28C13.267 28 13.518 27.896 13.707 27.707L27.707 13.707C27.896 13.518 28 13.267 28 13V5C28 4.449 27.551 4 27 4H19Z" />
		<path d="M22 14C19.794 14 18 12.206 18 10C18 7.794 19.794 6 22 6C24.206 6 26 7.794 26 10C26 12.206 24.206 14 22 14ZM22 8C20.897 8 20 8.897 20 10C20 11.103 20.897 12 22 12C23.103 12 24 11.103 24 10C24 8.897 23.103 8 22 8Z" />
	</svg>
);

export default Tag;
